import { useEffect } from "react";

// TODO: Fix when will be possible, this solution is a brute-force workaround https://github.com/vercel/next.js/issues/30828#issuecomment-997750399
export const useForceHtmlLangAttribute = (lang: string) => {
    useEffect(() => {
        document.documentElement.lang = lang;

        const langObserver = new MutationObserver(() => {
            if (document.documentElement.lang !== lang) {
                document.documentElement.lang = lang;
            }
        });
        langObserver.observe(document.documentElement, {
            attributeFilter: ["lang"],
        });

        return () => {
            langObserver.disconnect();
        };
    }, [lang]);
};
